import { render, staticRenderFns } from "./GeneralStatistics.vue?vue&type=template&id=9d998792&scoped=true"
import script from "./GeneralStatistics.vue?vue&type=script&lang=js"
export * from "./GeneralStatistics.vue?vue&type=script&lang=js"
import style0 from "./GeneralStatistics.vue?vue&type=style&index=0&id=9d998792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d998792",
  null
  
)

export default component.exports